<template>
  <button
    class="wg-gbtn"
    :class="{ ghost: ghost }"
    type="button"
    :disabled="busy"
    @click="openPopup"
  >
    <span v-if="busy" class="wg-spin" :class="{ dark: ghost }"></span>
    <span>{{ busy ? 'Connecting…' : label }}</span>
  </button>
</template>

<script>
/**
 * Google Identity Services authorization-code button (popup flow).
 * Thin wrapper around the shared requestGoogleAuthCode() helper; emits
 * `code` with the one-time authorization code the backend exchanges.
 */
import { requestGoogleAuthCode } from '@/utils/search-console-helper.js'

export default {
  name: 'GoogleAuthCodeButton',
  props: {
    label: {
      type: String,
      default: 'Connect',
    },
    ghost: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      busy: false,
    }
  },
  methods: {
    openPopup () {
      if (this.busy) return
      this.busy = true
      requestGoogleAuthCode()
        .then((code) => {
          this.$emit('code', code)
        })
        .catch((error) => {
          if (!error.popupClosed) {
            this.$emit('error', error.message)
          }
        })
        .finally(() => {
          this.busy = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './settings-card.scss';
</style>
